/**
 * src/components/pages/PromosPage.js
 *
 * Página de promociones y novedades.
 * Fetchea /data/promos.json directamente para reflejar cambios del admin.
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { signal, effect } from '@core/signal.js'
import { PROMO_TAGS } from '@/db/promos.db.js'

define('PromosPage', () => {
    const search    = signal('')
    const activeTag = signal('Todos')

    /* ── Banner ── */
    const banner = h('div', { className: 'promos-page__banner' },
        h('div', { className: 'promos-page__banner-inner' },
            h('span', { className: 'promos-page__label' }, '🎉 Promociones y novedades'),
            h('h1',   { className: 'promos-page__headline' }, 'Ofertas activas en Fusagasugá'),
            h('p',    { className: 'promos-page__sub' },
                'Descuentos, lanzamientos y beneficios exclusivos de negocios locales.'
            )
        )
    )

    /* ── Filtros ── */
    const searchInput = h('input', {
        type: 'text', className: 'promos-page__search',
        placeholder: '🔍 Buscar promo o negocio...'
    })
    searchInput.addEventListener('input', e => search.set(e.target.value))

    const tagBtns = PROMO_TAGS.map(tag => {
        const btn = h('button', { className: 'promos-page__tag-btn', type: 'button' }, tag)
        btn.addEventListener('click', () => activeTag.set(tag))
        effect(() => btn.classList.toggle('promos-page__tag-btn--active', activeTag.get() === tag))
        return btn
    })

    const filters = h('div', { className: 'promos-page__filters' },
        h('div', { className: 'promos-page__tags' }, ...tagBtns),
        searchInput
    )

    /* ── Grid reactivo ── */
    const grid    = h('div', { className: 'promos-page__grid' })
    const empty   = h('div', { className: 'promos-page__empty' },
        h('p', {}, '😕 No hay promociones que coincidan con tu búsqueda.')
    )
    const counter = h('p', { className: 'promos-page__counter' })

    /* allItems se actualiza cuando llegan los datos del servidor */
    const allItems = signal([])

    effect(() => {
        const all = allItems.get()
        const q   = search.get().toLowerCase()
        const tag = activeTag.get()

        const filtered = all.filter(p => {
            const matchTag  = tag === 'Todos' || p.tag === tag
            const matchText = !q || p.title.toLowerCase().includes(q) ||
                              (p.business || '').toLowerCase().includes(q)
            return matchTag && matchText
        })

        grid.innerHTML = ''
        filtered.forEach(promo => grid.appendChild(c('PromoPageCard', { promo })))
        counter.textContent = `${filtered.length} promoción${filtered.length !== 1 ? 'es' : ''} encontrada${filtered.length !== 1 ? 's' : ''}`
        empty.style.display = filtered.length === 0 ? 'block' : 'none'
    })

    function shuffle(arr) {
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]]
        }
        return arr
    }

    /* Fetch directo con cache buster */
    fetch(`/data/promos.json?t=${Date.now()}`)
        .then(r => r.json())
        .then(data => {
            allItems.set(shuffle((data.items || []).filter(p => p.enabled !== false)))
        })
        .catch(() => {})

    return h('div', { className: 'page page--promos' },
        c('Header'),
        banner,
        h('div', { className: 'promos-page__body' },
            filters,
            counter,
            grid,
            empty
        ),
        c('Footer')
    )
})
